import { render, staticRenderFns } from "./rosterEmpDtl.vue?vue&type=template&id=70080576&scoped=true&"
import script from "./rosterEmpDtl.vue?vue&type=script&lang=js&"
export * from "./rosterEmpDtl.vue?vue&type=script&lang=js&"
import style0 from "./rosterEmpDtl.vue?vue&type=style&index=0&id=70080576&prod&lang=scss&scoped=true&"
import style1 from "./rosterEmpDtl.vue?vue&type=style&index=1&id=70080576&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70080576",
  null
  
)

export default component.exports